import Handlebars from "utilities/vendor/handlebars/4.7.7/js/handlebars";
import hbs from "utilities/vendor/handlebars/4.7.7/js/handlebars";








'use strict'; 

const helpers = {





  meta: (values) => {








    function normalizeHTML(str1, str2, str3, str4, str5) {
      const str = str1 + ((typeof str2 === 'string') ? str2 : '') + ((typeof str3 === 'string') ? str3 : '') + ((typeof str4 === 'string') ? str4 : '') + ((typeof str5 === 'string') ? str5 : '');

      const replaceChars = {
        '‘': '\'',
        '’': '\'',
        '“': '"',
        '”': '"',
      };

      const encodedChars = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '©': '&copy;',
        '®': '&reg;',
        '™': '&trade;',
        Á: '&Aacute;',
        á: '&aacute;',
        É: '&Eacute;',
        é: '&eacute;',
        Í: '&Iacute;',
        í: '&iacute;',
        Ó: '&Oacute;',
        ó: '&oacute;',
        Ú: '&Uacute;',
        ú: '&uacute;',
        Ü: '&Uuml;',
        ü: '&uuml;',
        Ñ: '&Ntilde;',
        ñ: '&ntilde;',
        '¿': '&iquest;',
        '¡': '&iexcl;',
      };





      function isURL(string) {
        const regexp = new RegExp('^http(s?):', 'i'); 
        return regexp.test(string);
      }





      function decodeStr(string) { 
        let scopedString = string;
        Object.keys(replaceChars)
          .forEach((k) => {
            const regex = new RegExp(k, 'g');
            scopedString = scopedString.replace(regex, replaceChars[k]);
          });
        Object.keys(encodedChars)
          .forEach((k) => {
            const regex = new RegExp(encodedChars[k], 'g');
            scopedString = scopedString.replace(regex, k);
          });
        return scopedString;
      }





      function encodeStr(string) { 
        let scopedString = string;
        Object.keys(encodedChars)
          .forEach((k) => {
            const regex = new RegExp(k, 'g');
            scopedString = scopedString.replace(regex, encodedChars[k]);
          });
        return scopedString;
      }

      if (str !== undefined) {
        let scopedString = str;
        scopedString = decodeStr(scopedString);
        if (isURL(scopedString)) {
          return scopedString; 
        }
        return encodeStr(scopedString); 
      }
      return null;
    }



    const metaStr = [];

    let metaValue;
    let value;

    Object.keys(values)
      .forEach((key) => {
        metaValue = values[key];
        if (typeof metaValue === 'string') {
          value = metaValue;
        } else {
          value = metaValue.default;
        }
        value = normalizeHTML(value);
        switch (key) {
          case 'title':
            metaStr.push(`<title>${value}</title>`);
            break;
          case 'canonical':
            metaStr.push(`<link rel="canonical" href="${value}">`);
            break;
          case 'amphtml':
            metaStr.push(`<link rel="amphtml" href="${value}">`);
            break;
          case 'alternate':
            value = values[key];
            metaStr.push(`<link rel="alternate" href="${value.href}" hreflang="${value.hreflang}">`);
            break;
          case 'alternates':
            value = values[key];
            value.forEach(item => metaStr.push(`<link rel="alternate" href="${item.href}" hreflang="${item.hreflang}">`));
            break;
          case 'structuredData':


            break;
          case 'SI_TRADUC':


            break;
          case 'NO_TRADUC':


            break;
          default:

            if (value !== 'undefined') {
              let metaWritten = false;
              if (!metaWritten && key.substring(0, 2) === 'og') { metaStr.push(`<meta property="${key}" content="${value}">`); metaWritten = true; }
              if (!metaWritten && key.substring(0, 7) === 'twitter') { metaStr.push(`<meta name="${key}" content="${value}">`); metaWritten = true; }
              if (!metaWritten) metaStr.push(`<meta name="${key}" content="${value}">`);
            }
            break;
        }
      });

    return metaStr.join('\n');
  },







































  genericMeta: function genericMeta(tags, context = {}) {

    if (tags && typeof tags === 'object') {

      const validTags = ['meta', 'link'];


      const generatedTags = [];


      const tokenRegEx = /^(?:%%)(.*)(?:%%)$/;


      Object.keys(tags)
        .forEach((tagType) => {
          if (validTags.indexOf(tagType) !== -1) {

            tags[tagType].forEach((tag) => {

              const tagAttributes = [];





              const attributesReady = Object.keys(tag)
                .every((tagAttribute) => {

                  if (tag[tagAttribute] === true) {
                    tagAttributes.push(tagAttribute);


                    return true;
                  }


                  const testForToken = tokenRegEx.exec(tag[tagAttribute]);


                  if (testForToken) {

                    const tokenPath = testForToken[1].split('.');


                    let currentPath = context;




                    const resolvedPath = tokenPath.every((pathKey) => {

                      if (Object.prototype.hasOwnProperty.call(currentPath, pathKey)) {

                        currentPath = currentPath[pathKey];


                        return true;
                      }


                      return false;
                    });


                    if (resolvedPath && typeof currentPath === 'string') {

                      tagAttributes.push(`${tagAttribute}="${currentPath}"`);


                      return true;
                    }


                    return false;
                  }


                  tagAttributes.push(`${tagAttribute}="${tag[tagAttribute]}"`);


                  return true;
                });


              if (attributesReady) {

                generatedTags.push(`<${tagType} ${tagAttributes.join(' ')}>`);
              }
            });
          }
        });


      return new Handlebars.SafeString(generatedTags.join('\n'));
    }


    return null;
  },
};





class Helper {






  static register(Handlebars) {
    Object.keys(helpers)
      .forEach((key) => {
        Handlebars.registerHelper(key, helpers[key]);
      });
  }
}

module.exports = Helper;
